var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertExclamationWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.08434C7.31459 1.08434 1.08434 7.31459 1.08434 15C1.08434 22.6854 7.31459 28.9157 15 28.9157C22.6854 28.9157 28.9157 22.6854 28.9157 15C28.9157 7.31459 22.6854 1.08434 15 1.08434ZM0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1989 13.8634C15.8265 13.8634 16.3353 14.3722 16.3353 14.9998V21.3636C16.3353 21.9912 15.8265 22.5 15.1989 22.5C14.5713 22.5 14.0625 21.9912 14.0625 21.3636V14.9998C14.0625 14.3722 14.5713 13.8634 15.1989 13.8634Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0625 8.6364C14.0625 8.00878 14.5713 7.5 15.1989 7.5H15.2148C15.8424 7.5 16.3512 8.00878 16.3512 8.6364C16.3512 9.26401 15.8424 9.7728 15.2148 9.7728H15.1989C14.5713 9.7728 14.0625 9.26401 14.0625 8.6364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertExclamationWhite);
export default __webpack_public_path__ + "static/media/alert-exclamation-white.2dd0aa3a36f8c90b465c0070de328290.svg";
export { ForwardRef as ReactComponent };